/* eslint-disable */
import styled from 'styled-components'
import { Modal } from 'antd'

export const Wrapper = styled.div`
  table {
    thead {

    }
    tr {
      border-style: hidden !important;
      th {
        background: #ccc;
      }
      td:not(:last-child), th:not(:last-child) {
        position: relative;
        &::after {
          height: 50%;
          border-right: 1px solid gainsboro;
          content: '';
          position: absolute;
          right: 0;
        }
      }
      td:last-child a {
        color: #D14124 !important;
        font-weight: 700;
      }
      td.greenBg {
        color: #00B031;
        font-weight: 700;
      }
    }
  }
`


export const GeneratedWrapper = styled.div`
font-size: 10px;
button.newCustomer {
  background: linear-gradient(90deg, #D14124 -0.05%, #B02509 99.95%);
  box-shadow: 0px 4px 25px rgba(255, 0, 0, 0.2);
  border-radius: 4px;
  color: white;
  margin-bottom: 20px;
  padding-left: 25px;
  padding-right: 25px;
}
// .panelFirst {
//   margin-top: 5px;
//   .ant-col-12:last-child {
//     font-size: 16px;
//     &>div:first-child {
//       font-weight: 700;
//       font-size: 22px;
//     }
//   }
// }
.panel {
  margin-top: 10px;
  // line-height: 14px;
  margin-bottom: 10px;
  button {
    background: linear-gradient(90deg, #D14124 -0.05%, #B02509 99.95%);
    box-shadow: 0px 4px 25px rgba(255, 0, 0, 0.2);
    border-radius: 4px;
    color: white;
    margin-bottom: 20px;
    padding-left: 25px;
    padding-right: 25px;
  }
  .ant-col-12 {
    section {
      border: 1px solid;
      padding-bottom: 5px;
      height: 100%;
      div:first-child {
        border-bottom: 1px solid;
        font-weight: 600;
        margin-bottom: 3px;
        padding-bottom: 3px;
      }
      div {
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }
}
footer {
  margin-top: 20px;
  text-align: right;
  button {
    background: linear-gradient(90deg,#D14124 -0.05%,#B02509 99.95%);
    box-shadow: 0px 4px 25px rgb(255 0 0 / 20%);
    border-radius: 4px;
    color: white;
    margin-bottom: 20px;
    padding-left: 30px;
    padding-right: 30px;
    margin-right: 15px;
  }
}
// table {
//   tr {
//     th {
//       background: #ccc;
//       font-size: 10px;
//       padding: 3px;
//       text-align: center;
//     }
//     td {
//       font-size: 10px;
//       padding: 3px;
//       text-align: center;
//     }
//     td:last-child {
//       display: none;
//     }
//   } 
// }
.back {
  color: black;
  font-size: 20px;
  display: inline-block;
  align-items: center;
  cursor: pointer;
  span {
    margin-left: 10px;
  }
  i {
    line-height: 20px;
  }
}

.pdf-page.size-a4 {
  width: 6.2in;
  height: 8.7in;
}

.pdf-page.size-letter {
  width: 6.2in;
  height: 8.5in;
}

.pdf-page.size-executive {
  width: 5.4in;
  height: 7.8in;
}
.size-executive  .pdf-header {
  margin-bottom:  .1in;
}

.pdf-page {
  position:  relative;
  margin:  0  auto;
  // padding:  .4in  .3in;
  color:  #333;
  background-color:  #fff;
  box-shadow:  0  5px  10px  0  rgba(0,0,0,.3);
  box-sizing:  border-box;
  margin-top: 30px;
  // font-family: "Arial";

  
  .title {
    margin: 10px;
  }
  .panelFirst {
    padding-bottom: 5px;
    border-bottom: 3px solid;
    font-family: 'serif|bold';
  }
  .pdfBottom {
    font-family: 'serif|bold';
  }
}

.pdf-page .headerTitle {
  display: flex;
  align-items: flex-end;
  font-family:  "DejaVu Sans";
}
span.space5 {
  margin-left: 5px;
}
@media screen and (max-width: 768px) {
  footer {
    display: flex;
  }
}
`

export const StyleModal = styled(Modal)`
  & {
    header {
      svg {
        position: absolute;
        top: 10px;
        right: 10px;
      }
    }
    .ant-modal-footer {
      display: none !important;
    }
    .ant-modal-header {
      display: none !important;
    }
    .ant-modal-close {
      display: none !important;
    }
    .ant-modal-body {
      p {
        margin-top: 20px;
        form>div:last-child {
          text-align: right;
        }
        button:first-child {
          margin-right: 10px;
        }
      }
    }
  }
`